import moment from 'moment';
import 'moment-timezone';

const defaultUsageView = {
  loginTime: '-',
  protectedResource: '-',
  ipAddress: '-'
};

export default class ApiTokensService {
/** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    utils,
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.utils = utils;
  }

  getApiTokens() {
    return this.$http.get(this.#serviceBaseUrl())
      .then((resp) => {
        resp.data.apiTokens.forEach((apiToken) => {
          this.#normalizeApiToken(apiToken);
        });

        return resp;
      });
  }

  deleteApiToken(apiTokenModel) {
    return this.$http.post(this.#deleteServiceBaseUrl(), apiTokenModel);
  }

  createApiToken(apiTokenModel) {
    return this.$http.post(this.#serviceBaseUrl(), apiTokenModel);
  }

  doesItHaveUsage(apiToken) {
    return (apiToken?.usage?.length > 0);
  }

  getLastUse(apiToken) {
    if (this.doesItHaveUsage(apiToken)) {
      return apiToken.usage[0];
    }

    return undefined;
  }

  #normalizeApiToken(apiToken) {
    if (this.doesItHaveUsage(apiToken)) {
      apiToken.usage.forEach(usage => {
        this.#normalizeApiTokenUsage(usage);
      });
    }

    const lastUsage = this.#getLastUsage(apiToken);
    apiToken.lastUsage = this.#normalizeApiTokenUsage(lastUsage);
  }

  #normalizeApiTokenUsage(apiTokenUsage) {
    if (apiTokenUsage) {
      apiTokenUsage.loginTime = moment(apiTokenUsage.loginTime).format('MMM DD, YY h:mm:ss a');

      return apiTokenUsage;
    }

    return defaultUsageView;
  }

  #getLastUsage(apiToken) {
    if (apiToken?.usage) {
      return apiToken.usage[0];
    }

    return {};
  }

  #serviceBaseUrl() {
    return this.ngAuthSettings.apiServiceBaseUri + 'ApiTokens';
  }

  #deleteServiceBaseUrl() {
    return this.ngAuthSettings.apiServiceBaseUri + 'ApiTokens/Delete';
  }
}
